import React, { useState, useEffect } from 'react';

import './OfficeGroupMenu.css'; // Import the OfficeGroupMenu component

const OfficeGroupMenu = ({ title, lines, bodily_parts, offices, docName, setDoctors, setBodilyParts, setOffices, setInsurances, setOriginalDoctors, setEditBookArray, selectedDoctor, editBookArray, setSelectedDoctor, setOpenDropdown, setKey, openDropdown, manualSetDoctors, showDeleteModal, setShowDeleteModal, handleDeleteModal, deleting, handleSaveLocations }) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [locationClicked, setLocationClicked] = useState(false);
    const [locationsToSend, setLocationsToSend] = useState([]);
    const [saving, setSaving] = useState(false);
    const [keyTwo, setKeyTwo] = useState(0);
    const [showAddForm, setShowAddForm] = useState(false); // State variable to track if the add form should be shown
    const [errorAgeGroupCreate, setErrorAgeGroupCreate] = useState(null);

    const updateSelectedDoctor = (updatedDoctor) => {
        setSelectedDoctor((prevDoctor) => ({
            ...prevDoctor,
            doctor: {
                ...prevDoctor.doctor,
                age_groups: prevDoctor.doctor.age_groups.map((ageGroup) => {
                    const updatedAgeGroup = updatedDoctor.doctor.age_group_array.find(
                        (updatedAgeGroup) => updatedAgeGroup.name === ageGroup.name
                    );
                    return updatedAgeGroup ? { ...ageGroup, ...updatedAgeGroup } : ageGroup;
                }),
                locations: prevDoctor.doctor.offices.map((office) => {
                    const updatedOffice = updatedDoctor.doctor.offices.find(
                        (updatedOffice) => updatedOffice.name === office.name
                    );
                    return updatedOffice ? { ...office, ...updatedOffice } : office;
                }),
            },
        }));
    };
    // editBookArray changes
    useEffect(() => {
        setKeyTwo(prevKey => prevKey + 1);
    }, [editBookArray]);
    const handleLocationClicked = (item, task) => {
        const isDuplicate = locationsToSend.some(location => location.item === item);
        if (!isDuplicate) {

            if (task === 'Remove Add') {
                const updatedLocations = locationsToSend.filter((loc) => loc !== item);
                setLocationsToSend(updatedLocations);
                if (updatedLocations.length === 0) {
                    setSelectedItem(null);
                }
            } else if (task === 'Remove Remove') {
                const updatedLocations = locationsToSend.filter((loc) => loc !== item);
                setLocationsToSend(updatedLocations);
                if (updatedLocations.length === 0) {
                    setSelectedItem(null);
                }
            } else {
                setLocationsToSend(prevLocations => [
                    ...prevLocations,
                    {
                        task: task,
                        item: item
                    }
                ]);
            }
        }
    }

    const handleItemClick = (item, event, task) => {
        if (event) {
            event.stopPropagation();
        }
        // send it right to the backend to save, it was easier before and you forgot
        if (task === 'Remove') {
            handleSaveLocations(item.name, true);
        } else {
            handleSaveLocations(item.name, false);
        }
    }
    

    // useEffect(() => {
    //     console.log('OfficeGroupMenu Props:', {
    //         title,
    //         lines,
    //         bodily_parts,
    //         offices,
    //         docName,
    //         setDoctors,
    //         setBodilyParts,
    //         setOffices,
    //         setInsurances,
    //         setOriginalDoctors,
    //         setEditBookArray,
    //         selectedDoctor,
    //         editBookArray,
    //         setSelectedDoctor,
    //         setOpenDropdown,
    //         setKey,
    //         openDropdown,
    //         manualSetDoctors,
    //         showDeleteModal,
    //         setShowDeleteModal,
    //         handleDeleteModal,
    //         deleting
    //     });

    //     console.log('OfficeGroupMenu State:', {
    //         selectedItem,
    //         locationClicked,
    //         locationsToSend,
    //         saving,
    //         keyTwo,
    //         showAddForm,
    //         errorAgeGroupCreate
    //     });
    // }, [title, lines, bodily_parts, offices, docName, setDoctors, setBodilyParts, setOffices, setInsurances, setOriginalDoctors, setEditBookArray, selectedDoctor, editBookArray, setSelectedDoctor, setOpenDropdown, setKey, openDropdown, manualSetDoctors, showDeleteModal, setShowDeleteModal, handleDeleteModal, deleting, selectedItem, locationClicked, locationsToSend, saving, keyTwo, showAddForm, errorAgeGroupCreate]);


    return (
        <div className="dropdown-age-group" key={keyTwo}>
            <div className="dropdown-age-group-content">
                {/* Left Column Under Age Groups */}
                <div className="column-office-group">
                    {lines.sort((a, b) => a.name.localeCompare(b.name)).filter((line) => line.covered).map((item, i) => (
                        <div key={i} id="remove-item-age-group" className="menu-item-age-group-remove">
                            <div onClick={(event) => handleItemClick(item, event, 'Remove')} style={{ display: 'flex', flexDirection: 'row' }}><i className="far fa-check-square"></i>
                                <span style={{ color: 'black', fontWeight: '200', textShadow: 'none', marginLeft: '5px' }}>
                                    {item.name}
                                </span>
                            </div>
                        </div>
                    ))}
                    {selectedItem && (
                                <div className="details" style={{  marginTop: '10px' }}>
                                    <span style={{ textAlign: 'center', width: '95%', alignSelf: 'center', color: 'white', textShadow: 'none', opacity: '0.7', fontSize: '1.5rem', borderBottom: '1px solid white', borderRadius: '50px 0px', backgroundColor: 'rgba(218, 145, 0, 0.7)' }}>
                                        Edit
                                    </span>
                                    {/* Locations */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', height: '100px', padding: '0px 10px 0px 0px', margin: '10px 0px 10px 0px' }}>
                        
                                        {/* Cart */}
                                        <div style={{ width: '100%', padding: '0px 0px 0px 5px', overflowX: 'hidden', height: 'inherit' }}>
                                            {locationsToSend.map((location, index) => (
                                                <span
                                                    key={index}
                                                    className={`cart-item ${location.task === 'Add' ? 'add' : 'remove'}`}
                                                    onClick={() => handleLocationClicked(location, `Remove ${location.task}`)}
                                                >
                                                    <span
                                                        // className="plus-or-minus"
                                                        style={{ color: location.task === 'Add' ? 'green' : 'red', fontSize: '1.5rem', padding: '0px 3px 0px 0px', margin: '-3px 0px 3px 0px', lineHeight: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minWidth: '0px', alignSelf: 'center', justifySelf: 'center' }}
                                                    >
                                                        {location.task === 'Add' ? '+' : '-'}
                                                    </span>
                                                    {location.name}
                                                </span>
                                            ))}
                                        </div>



                                    </div>
                                </div>
                    )}

                </div>
                {/* Right Column Under Age Groups */}
                <div className="column-office-group">


                    {lines
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .filter((line) => !line.covered)
                        .map((item, i) => (
                            <div
                                key={item.name}
                                id="add-item-age-group"
                                className="menu-item-age-group-add"
                                onClick={(event) => {
                                    handleItemClick(item, event, 'Add');
                                }} 
                            >
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <i className="far fa-square"></i>
                                    <span style={{ color: 'black', fontWeight: '200', textShadow: 'none', marginLeft: '5px' }}>
                                        {item.name}
                                    </span>
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default OfficeGroupMenu;
